import { Sort, SortOrder } from '../grid/experimental.grid';

import { FocusSelectorGoalModel } from './focus-selector-goal.model';
import { ProjectionEvaluationRangeId } from './focus-selector-projection-evaluation-range.enum';
import { Context, FocusSelectorGrid } from './focus-selector.grid.model';

export enum ColumnID {
    METRIC = 'metric',
    OA = 'oa',
    ON_SCORECARD = 'on_scorecard',
    ACTUAL = 'actual',
    TARGET = 'target',
    PROJECTED_15_DAY_IMPROVEMENT = 'projected_15_day_improvement',
    PROJECTED_30_DAY_IMPROVEMENT = 'projected_30_day_improvement',
    PROJECTED_60_DAY_IMPROVEMENT = 'projected_60_day_improvement',
    IS_SELECTED_METRIC = 'is_selected_metric',
}

export interface RowContext extends Context {
    goal: FocusSelectorGoalModel;
}

export interface CellContext extends Partial<FocusSelectorGoalModel>, Context {
    checked?: boolean;
}

export interface LoadGoalsGrid
    extends FocusSelectorGrid<RowContext, CellContext> {
    selection: {
        goals: FocusSelectorGoalModel[];
        projectionEvalCol: {
            metricId: FocusSelectorGoalModel['metricId'];
            range: ProjectionEvaluationRangeId;
        };
    };
}

export const defaultSortDefs: Sort[] = [
    {
        columnId: ColumnID.IS_SELECTED_METRIC,
        order: SortOrder.DESC,
    },
    {
        columnId: ColumnID.PROJECTED_30_DAY_IMPROVEMENT,
        order: SortOrder.DESC,
    },
];
